import { Grid2 as Grid, Card, CardContent, IconButton, Divider } from "@mui/material"
import { Edit, Delete } from "@mui/icons-material"
import { Rimediazione } from "../types"
import { InlineField } from "./DataField"
import { useTranslation } from "react-i18next"
import useUserCanWriteAndDelete from "../hooks/permissions"
import { useIsMobile } from "../hooks/mobile"

type RimediazioneCardProps = {
  rimediazione: Rimediazione
  onDelete: (rimediazione: Rimediazione) => void
  onUpdate: (rimediazione: Rimediazione) => void
}

export default function RimediazioneCard({ rimediazione, onDelete, onUpdate }: RimediazioneCardProps) {
  const { t } = useTranslation()
  const userCanWriteAndDelete = useUserCanWriteAndDelete()
  const isMobile = useIsMobile()

  return (
    <Card>
      <CardContent sx={{ position: "relative" }}>
        {userCanWriteAndDelete && !isMobile && (
          <IconButton
            onClick={() => onUpdate(rimediazione)}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              color: "primary.main",
            }}
            aria-label="edit"
          >
            <Edit />
          </IconButton>
        )}
        <InlineField label={t("general.data")} value={rimediazione.data} />
        <InlineField label={t("rimediazione.tipo")} value={rimediazione.tipo_data?.termine} boolean />
        <InlineField
          label={t("rimediazione.velocita_rimediazione")}
          value={rimediazione.velocita_rimediazione_data?.termine}
        />
        <InlineField label={t("rimediazione.esposizione")} value={rimediazione.esposizione_data?.termine} />
        <InlineField label={t("rimediazione.flusso")} value={rimediazione.flusso} />
        <InlineField label={t("rimediazione.formato_img")} value={rimediazione.formato_img_data?.termine} />
        <InlineField label={t("rimediazione.framerate")} value={rimediazione.framerate_data?.termine} />
        <InlineField label={t("rimediazione.risoluzione")} value={rimediazione.risoluzione} />
        <InlineField label={t("rimediazione.codec")} value={rimediazione.codec_data?.termine} />
        <InlineField label={t("rimediazione.tecnica_suono")} value={rimediazione.tecnica_suono_data?.termine} />
        <InlineField label={t("rimediazione.tipo_suono")} value={rimediazione.tipo_suono_data?.termine} />

        <Grid container spacing={2}>
          <Grid size={6}>
            <InlineField label={t("rimediazione.sonoro")} value={rimediazione.sonoro} boolean />
          </Grid>
          <Grid size={6}>
            <InlineField label={t("rimediazione.decad_col")} value={rimediazione.decad_col} boolean />
          </Grid>
        </Grid>

        <InlineField label={t("rimediazione.graffi")} value={rimediazione.graffi_data?.termine} />

        <InlineField label={t("rimediazione.scan_prewet")} value={rimediazione.scan_prewet} boolean />

        <InlineField label={t("rimediazione.note_decad")} value={rimediazione.note_decad} />

        <InlineField
          label={t("rimediazione.strumento_scansione")}
          value={rimediazione.strumento_scansione_data?.termine}
        />

        <Divider sx={{ marginY: 2 }} />

        <InlineField label={t("general.note")} value={rimediazione.note} />

        <Divider sx={{ marginY: 2 }} />

        <InlineField label={t("rimediazione.esterna")} value={rimediazione.esterna} boolean />
        <InlineField label={t("rimediazione.lab")} value={rimediazione.lab} />
        <InlineField label={t("general.luogo")} value={rimediazione.luogo_data?.nome} />
        <Grid container spacing={2}>
          <Grid size={6}>
            <InlineField label={t("rimediazione.uscita")} value={rimediazione.uscita} />
          </Grid>
          <Grid size={6}>
            <InlineField label={t("rimediazione.rientro")} value={rimediazione.rientro} />
          </Grid>
        </Grid>
        {userCanWriteAndDelete && !isMobile && (
          <IconButton
            onClick={() => onDelete(rimediazione)}
            sx={{
              position: "absolute",
              bottom: 8,
              right: 8,
              color: "error.main",
            }}
            aria-label="delete"
          >
            <Delete />
          </IconButton>
        )}
      </CardContent>
    </Card>
  )
}
